import axios from "axios";

// The backend's error body ({error, details, requestId}) as one line, falling back to the
// thrown error's message.
export const getApiErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const body: unknown = error.response?.data;
    if (body && typeof body === "object") {
      const errorBody = body as {
        error?: unknown;
        details?: unknown;
        requestId?: unknown;
      };
      const summary =
        typeof errorBody.error === "string" ? errorBody.error : null;
      const details =
        typeof errorBody.details === "string" ? errorBody.details : null;
      const requestId =
        typeof errorBody.requestId === "string" ? errorBody.requestId : null;
      const parts = [summary, details, requestId && `Request ID: ${requestId}`];
      const message = parts.filter(Boolean).join(": ");
      if (message) {
        return message;
      }
    }
  }
  return error instanceof Error ? error.message : String(error);
};
